import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
import Icon from '../../../components/AppIcon';

const DemographicChart = ({ data, title, subtitle, type }) => {
  const COLORS = ['#02453e', '#1b8a5b', '#ffc107', '#4a90a4', '#ff6b35'];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-conservation-lg">
          <p className="text-sm font-medium text-foreground mb-1">{payload?.[0]?.payload?.name}</p>
          <p className="text-xs text-muted-foreground">
            Visitors: <span className="text-primary font-semibold">{payload?.[0]?.value?.toLocaleString()}</span>
          </p>
          <p className="text-xs text-muted-foreground">
            Percentage: <span className="text-secondary font-semibold">{payload?.[0]?.payload?.percentage}%</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation border border-border">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-semibold text-foreground mb-1">{title}</h3>
          <p className="text-sm text-muted-foreground">{subtitle}</p>
        </div>
        <Icon name={type === 'origin' ? 'Globe' : type === 'age' ? 'Users' : 'Clock'} size={24} className="text-primary" />
      </div>
      <div className="w-full h-80" aria-label={`${title} Bar Chart`}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f3a39" />
            <XAxis 
              dataKey="name" 
              stroke="#b0bec5"
              angle={-45}
              textAnchor="end"
              height={80}
              tick={{ fill: '#b0bec5', fontSize: 12 }}
            />
            <YAxis 
              stroke="#b0bec5"
              tick={{ fill: '#b0bec5', fontSize: 12 }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="circle"
            />
            <Bar dataKey="visitors" fill="#02453e" radius={[8, 8, 0, 0]} name="Total Visitors">
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4 grid grid-cols-2 md:grid-cols-3 gap-3">
        {data?.slice(0, 6)?.map((item, index) => (
          <div key={item?.name} className="flex items-center gap-2">
            <div 
              className="w-3 h-3 rounded-full" 
              style={{ backgroundColor: COLORS?.[index % COLORS?.length] }}
            />
            <span className="text-xs text-muted-foreground">{item?.name}</span>
            <span className="text-xs font-medium text-foreground ml-auto">{item?.percentage}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DemographicChart;